module.exports = __webpack_public_path__ + "9c8cb9f1483b98aff32783ec6222b7de.pdf";